import { FC, useContext } from 'react';
import classnames from 'classnames';
import { selectMenuState } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';
import { DefaultPrivateLayoutContext } from 'routes/DefaultPrivateLayout';
import { DefaultPrivateLayoutContextProps } from 'routes/types';

interface ModalWrapperProps {
  children: React.ReactNode;
}

const ModalWrapper: FC<ModalWrapperProps> = ({ children }) => {
  const isMenuActive = useAppSelector(selectMenuState);

  const { isFullScreenLayout } = useContext<DefaultPrivateLayoutContextProps>(DefaultPrivateLayoutContext);

  return (
    <div
      className={classnames('absolute top-0 z-50 h-full bg-black/5 backdrop-blur-sm', {
        'inset-x-0 w-full': isFullScreenLayout,
        'right-0': !isFullScreenLayout,
        'sm:w-[calc(100%-255px)]': isMenuActive && !isFullScreenLayout,
        'sm:w-[calc(100%-100px)]': !isMenuActive && !isFullScreenLayout
      })}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{children}</div>
    </div>
  );
};

export default ModalWrapper;
